import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBulkBlankTenantSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle opacity={0.88} cx={28} cy={28} r={28} fill="#56A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 16a1.5 1.5 0 011.5-1.5h9A1.5 1.5 0 0134 16v1H22v-1zm-3 4a1.5 1.5 0 011.5-1.5h15A1.5 1.5 0 0137 20v1.5H19V20zm-3 4.5a1.5 1.5 0 011.5-1.5h21a1.5 1.5 0 011.5 1.5v15a1.5 1.5 0 01-1.5 1.5h-21a1.5 1.5 0 01-1.5-1.5v-15zm12 7.152A2.826 2.826 0 1028 26a2.826 2.826 0 000 5.652zm0 .652c-1.277 0-1.982.173-2.474.346C24.31 33.077 23 33.958 23 35.886c0 .489.35.853.962 1.053.744.244 2.635.305 4.038.305 1.403 0 3.294-.06 4.038-.305.612-.2.962-.564.962-1.053 0-1.928-1.31-2.81-2.526-3.236-.492-.173-1.197-.346-2.474-.346z"
        fill="#fff"
      />
      <circle cx={38} cy={36} r={8} fill="#8F9DD6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.2 32a.2.2 0 00-.2.2V35h-2.8a.2.2 0 00-.2.2v1.6c0 .11.09.2.2.2H37v2.8c0 .11.09.2.2.2h1.6a.2.2 0 00.2-.2V37h2.8a.2.2 0 00.2-.2v-1.6a.2.2 0 00-.2-.2H39v-2.8a.2.2 0 00-.2-.2h-1.6z"
        fill="#fff"
      />
    </svg>
  );
}

SvgBulkBlankTenantSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBulkBlankTenantSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBulkBlankTenantSelected svgRef={ref} {...props} />
));
export default ForwardRef;
